import { render, staticRenderFns } from "./WikiPageImport.vue?vue&type=template&id=084983a0"
import script from "./WikiPageImport.vue?vue&type=script&lang=ts"
export * from "./WikiPageImport.vue?vue&type=script&lang=ts"
import style0 from "./WikiPageImport.vue?vue&type=style&index=0&id=084983a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports